var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('GradientBox',{staticClass:"count",attrs:{"primary-color-var":_vm.primaryColorVar}},[_c('div',{staticClass:"data"},[_c('h1',[_vm._v(_vm._s(_vm.count))]),_vm._v(" "),_c('label',[_vm._v(_vm._s(_vm.name))])])])}
var staticRenderFns = []

export { render, staticRenderFns }